import React from 'react'
import { Field, Form, updateFormValues, useForm, useWatch } from '../../form'
import { actualTimeValidate } from '../../containers/validate'
import { Button, Dialog } from '@material-ui/core'
import { convertIntToState_ws } from '../../utils/openForWork.utils'
import classNames from 'classnames'
import { requestEditActualHour } from '../../actions'
import { useDispatch } from 'react-redux'
import { formatTime } from '../../utils/openForWork.utils'
import { CloseIcon } from './closeIcon.component'

const WorkShiftDetails = ({
  classes,
  t,
  selectedWorkshift,
  setSelectedWorkshift,
  task_description,
  company_name,
  workshift_date,
  working_hours,
  location,
  workshift_lastdate,
  workshift_status_entrepreneur,
  additional_info,
  workshift_start_time,
  workshift_endtime,
  actualworkshift_starttime,
  actualworkshift_endtime,
  workshift_additional_comments,
  workshift_remarks = null
}) => {
  const updateActualHoursDefaultValues = {
    startTime: actualworkshift_starttime,
    endTime: actualworkshift_endtime,
    note: workshift_additional_comments
  }
  const [isEditTime, setIsEditTime] = React.useState(false)
  const dispatch = useDispatch()
  const form = useForm({
    name: 'actualTime',
    onSubmit: onSubmit,
    defaultValues: {
      startTime: workshift_start_time,
      endTime: workshift_endtime,
      note: ''
    },
    validator: (values) =>
      actualTimeValidate(values, workshift_start_time, workshift_endtime)
  })
  const { control } = form
  function onSubmit(values) {
    dispatch(requestEditActualHour(values, selectedWorkshift))
    setSelectedWorkshift(null)
  }
  const handleEditTime = () => {
    setIsEditTime(!isEditTime)
  }

  React.useEffect(() => {
    if (isEditTime) {
      dispatch(updateFormValues('actualTime', updateActualHoursDefaultValues))
    }
  }, [isEditTime])

  const { startTime, endTime } = useWatch({
    fields: ['startTime', 'endTime'],
    control
  })

  const isStartTimeDifferent = startTime !== workshift_start_time
  const isEndTimeDifferent = endTime !== workshift_endtime
  return (
    <div>
      <div
        style={{
          border: '1px solid #D3D3D3',
          borderRadius: '5px'
        }}
      >
        <div style={{ padding: '25px' }}>
          <div>
            <p className={classes.previewLabel}>{t('workshift.col1')}</p>
            <p>{task_description}</p>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>{t('workshift.col2')}</p>
              <p>{company_name}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>{t('workshift.col3')}</p>
              <p>{workshift_date}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>{t('workshift.col4')}</p>
              <p>{working_hours}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>{t('workshift.col6')}</p>
              <p>{location}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>{t('workshift.col7')}</p>
              <p>{workshift_lastdate}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>{t('workshift.col8')}</p>
              <p>{convertIntToState_ws(workshift_status_entrepreneur)}</p>
            </div>
          </div>
          <div>
            <p className={classes.previewLabel}>{t('workshift.col9')}</p>
            <div
              dangerouslySetInnerHTML={{ __html: additional_info }}
              style={{ overflowWrap: 'break-word' }}
            />
          </div>
        </div>
      </div>
      {(workshift_status_entrepreneur === 2 ||
        workshift_status_entrepreneur === 3 ||
        workshift_status_entrepreneur === 6) && (
        <div
          style={{
            border: '1px solid #D3D3D3',
            borderRadius: '5px',
            marginTop: '15px',
            padding: '25px'
          }}
        >
          <div>
            <b>
              {' '}
              {(workshift_status_entrepreneur === 2 ||
                workshift_status_entrepreneur === 6) && (
                <p>{t('workshift.p3')}</p>
              )}
              {workshift_status_entrepreneur === 3 && (
                <p>{t('workshift.p4')}</p>
              )}
            </b>
          </div>
          <div className="row">
            <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3">
              <p className={classes.previewLabel}>{t('workshift.cell2')}</p>
              <p>{formatTime(actualworkshift_starttime)}</p>
            </div>
            <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3">
              <p className={classes.previewLabel}>{t('workshift.cell3')}</p>
              <p>{formatTime(actualworkshift_endtime)}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <p className={classes.previewLabel}>{t('workshift.notep')}</p>
              <p style={{ overflowWrap: 'break-word' }}>
                {workshift_additional_comments}
              </p>
            </div>
          </div>
          {workshift_remarks && <hr />}
          {workshift_remarks?.map(
            (item, index) =>
              item?.workshift_remarks !== '' && (
                <div key={index}>
                  <p style={{ overflowWrap: 'break-word' }}>
                    {item.workshift_remarks}
                  </p>
                </div>
              )
          )}
        </div>
      )}
      {workshift_status_entrepreneur === 6 && (
        <div>
          <div className="pull-right" style={{ marginTop: '10px' }}>
            <Button variant="contained" onClick={handleEditTime}>
              {t('workshift.btn10')}
            </Button>
          </div>
          <Dialog open={isEditTime} fullWidth maxWidth="md">
            <CloseIcon
              fontSize="large"
              onClick={() => {
                setIsEditTime(false)
              }}
            />
            <div style={{ padding: '25px' }}>
              <ActualTimeForm
                form={form}
                control={control}
                workshift_status_entrepreneur={workshift_status_entrepreneur}
                t={t}
                classes={classes}
                isStartTimeDifferent={isStartTimeDifferent}
                isEndTimeDifferent={isEndTimeDifferent}
              />
            </div>
          </Dialog>
        </div>
      )}
      {workshift_status_entrepreneur === 1 && (
        <div
          style={{
            marginTop: '15px',
            border: '1px solid #D3D3D3',
            borderRadius: '5px'
          }}
        >
          <div style={{ padding: '25px' }}>
            <ActualTimeForm
              form={form}
              control={control}
              workshift_status_entrepreneur={workshift_status_entrepreneur}
              t={t}
              classes={classes}
              isStartTimeDifferent={isStartTimeDifferent}
              isEndTimeDifferent={isEndTimeDifferent}
            />
          </div>
        </div>
      )}
    </div>
  )
}

const ActualTimeForm = (props) => {
  const {
    form,
    control,
    workshift_status_entrepreneur,
    t,
    classes,
    isStartTimeDifferent,
    isEndTimeDifferent
  } = props
  return (
    <Form {...form}>
      <div
        style={{
          marginTop: 'auto',
          fontSize: '13px'
        }}
      >
        <p>
          <b>{t('workshift.p2')}</b>{' '}
        </p>
      </div>
      <div className="row">
        <div
          className="col-xs-6 col-sm-6 col-md-3 col-lg-3"
          style={{ marginTop: '22px' }}
        >
          <Field
            label={t('workshift.fld1')}
            name="startTime"
            inputType="timepicker-selection"
            control={control}
            className={classNames(classes.resize)}
            labelStyle={{ fontWeight: 500 }}
            updateStyle={{
              width: '150px'
            }}
          />
        </div>
        <div
          className="col-xs-6 col-sm-6 col-md-3 col-lg-3"
          style={{
            marginTop: '22px'
          }}
        >
          <Field
            label={t('workshift.fld2')}
            name="endTime"
            inputType="timepicker-selection"
            control={control}
            className={classNames(classes.resize)}
            labelStyle={{ fontWeight: 500 }}
            updateStyle={{
              width: '150px'
            }}
          />
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <Field
            name="note"
            label={
              isStartTimeDifferent || isEndTimeDifferent
                ? t('workshift.note') + '*'
                : t('workshift.note')
            }
            inputType="textfield"
            control={control}
            className={classNames(classes.textField2, classes.resize)}
            labelStyle={{
              fontSize: '14px',
              fontWeight: 500,
              color: 'black'
            }}
            // multiline
            inputMaxLength={80}
            helperTextStyle={{
              marginTop: '0px',
              height: '0px'
            }}
          />
        </div>
      </div>
      <div className="row">
        <div
          style={{
            margin: '10px 16px'
          }}
          className="pull-right"
        >
          <Button
            variant="contained"
            type="submit"
            disabled={
              workshift_status_entrepreneur !== 1 &&
              workshift_status_entrepreneur !== 6
                ? true
                : false
            }
          >
            {t('workshift.btn8')}
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default WorkShiftDetails
